import { graphql } from "@/shared/gql";
import { useCompanyId } from "@/entities/company/hooks/use-company-id";
import { useSuspenseQuery } from "@apollo/client";
import { getPreloadQuery } from "@/shared/gql/apollo-client";

const FetchReviewableViews = graphql(`
  query FetchReviewableViews($companyId: ID!, $tenderId: ID!) {
    currentUser(company: $companyId) {
      id
      reviewableViews(tenderId: $tenderId) {
        id
        title
      }
    }
  }
`);

export const useFetchReviewableViewsQuery = (tenderId: string) => {
  const companyId = useCompanyId();

  return useSuspenseQuery(FetchReviewableViews, {
    variables: { companyId, tenderId },
  });
};

// Warms the Apollo cache during route transition so the side panel's suspense
// read hits a pre-warmed cache instead of firing only after the detail query
// resolves.
export const preloadReviewableViewsQuery = (
  companyId: string,
  tenderId: string,
) => {
  getPreloadQuery()(FetchReviewableViews, {
    variables: { companyId, tenderId },
  });
};
